import requestCountry from 'js/lib/requestCountry';

import authenticationEpicClient from 'bundles/epic/clients/authentication';

export const isTermsOfUseRolloutForUS = () => {
  return requestCountry.get() === 'US' && authenticationEpicClient.preview('enableTermsOfUseAcceptance');
};
export const shouldShowCheckboxTermsOfUse = () => {
  return isTermsOfUseRolloutForUS();
};

export const shouldShowLegalConsolidationAuthFlow = () => {
  return requestCountry.get() === 'US' && authenticationEpicClient.preview('enableLegalConsolidationAuthFlow');
};

export const generateImpressionForEnableLegalConsolidationAuthFlow = () =>
  authenticationEpicClient.get('enableLegalConsolidationAuthFlow');

export default {
  shouldShowCheckboxTermsOfUse,
  isTermsOfUseRolloutForUS,
};
